import {BibTipoDocumentoModel} from '@/models/biblioteca/bibtipodocumento/bibtipodocumento.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class BibTipoDocumentoService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<BibTipoDocumentoModel>>> {
  return api.post <DataSource <BibTipoDocumentoModel>>('/BibTipoDocumento/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(bibTipoDocumento: BibTipoDocumentoModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/BibTipoDocumento', bibTipoDocumento);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/BibTipoDocumento/' + id);
 }

 atualizar(bibTipoDocumento: BibTipoDocumentoModel): Promise<AxiosResponse> {
  return api.put('/BibTipoDocumento', bibTipoDocumento);
 }

 async get(id: number): Promise<BibTipoDocumentoModel> {
  const result = await api.get<BibTipoDocumentoModel>(`/BibTipoDocumento/${id.toString()}`);
  return result.data;
 }
 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/BibTipoDocumento/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }
}
export default new BibTipoDocumentoService();
